import { boot } from 'quasar/wrappers'
import axios from 'axios'

const api = axios.create({
  baseURL: process.env.API_BASE_URL,
  timeout: 50000,
  headers: {
    get: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    post: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  },
  responseType: 'json'
})

api.interceptors.response.use(
  response => { // 200
    return response
  },
  error => {
    const {status} = error.response
    switch (status) {
      case 422:
        // TODO: バリデーションエラー
        return error.response
        break;

      default:
        // TODO: 404エラー表示
        break;
    }
  }
)

export default boot(({ app }) => {
  // for use inside Vue files (Options API) through this.$axios and this.$api

  app.config.globalProperties.$axios = axios
  // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
  //       so you won't necessarily have to import axios in each vue file

  app.config.globalProperties.$api = api
  // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
  //       so you can easily perform requests against your app's API
})

export { axios, api }
